import "antd/es/card/style";
import _Card from "antd/es/card";
import "antd/es/space/style";
import _Space from "antd/es/space";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { DealWithCardItem } from './utils';
import Typography from '../typography';
import './style/index';

var IglooCardPage = function IglooCardPage(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  var title = props.title,
      _props$extraButtons = props.extraButtons,
      extraButtons = _props$extraButtons === void 0 ? [] : _props$extraButtons,
      pageTitleIcon = props.pageTitleIcon,
      pageStatusIcon = props.pageStatusIcon;
  var extraButtonsWithKey = extraButtons.map(function (button, index) {
    return _jsx("div", {
      children: button
    }, index);
  });

  var titleContent = _jsxs(_Space, {
    size: 8,
    children: [_jsx("span", {
      children: pageTitleIcon
    }), _jsx(Typography, {
      level: "h3a",
      children: title
    }), pageStatusIcon]
  });

  return _jsx(_Card, {
    style: style,
    className: classnames('igloo-card-page', className),
    title: titleContent,
    extra: _jsx(_Space, {
      size: 18,
      children: extraButtonsWithKey
    }),
    children: DealWithCardItem(children, true)
  });
};

export default IglooCardPage;